import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Traductions principales
import enTranslation from './locales/en/common.json';
import frTranslation from './locales/fr/common.json';

// Services
import enServices from './locales/en/services.json';
import frServices from './locales/fr/services.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
      services: enServices // Namespace "services"
    },
    fr: {
      translation: frTranslation,
      services: frServices // Namespace "services"
    }
  },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false }
});

export default i18n;